// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header-menu-item-link{padding-right:1.6rem}.header-menu-item-link img{height:100%;-o-object-fit:contain;object-fit:contain}.header-menu-item-link img[alt=\"Living Room\"],.header-menu-item-link img[alt=Bedroom]{mix-blend-mode:multiply}.header-menu-item-link img[alt=Clearance]{height:56px;width:56px}.header-menu-item-link-image{height:64px}.header-menu-item-link-text{margin-right:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
